import React from "react";

const HowFreezeTheirCredit = (props: any) => {
    return (
        <div id="16-or-17-year-old-freeze">
            <div>
                <p>
                    They must follow these steps themselves to place a Freeze on their TransUnion credit report. You cannot request a Protected Consumer Freeze,
                    since they are no longer a minor (defined as under 16).
                </p>
            </div>
            <div>
                <p>If you are either 16-or-17-years old, you will need to mail in your Freeze request.</p>
            </div>
            <div className="margin-left-m margin-top-xs">
                <p>1. Please send TransUnion a letter requesting a freeze and include the following information:</p>
                <ul>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>Your name</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <strong>&#x2022;</strong>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>Current address (If you have lived here less than 2 years, provide your previous address also)</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>Your TransUnion file number (if applicable)</div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <strong>&#x2022;</strong>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>Social Security number</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>Date of birth</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div className="margin-left-m margin-top-xs">
                <p>2. Also include a copy of documentation that provides 'sufficient proof of identification' that you are who you really are, such as:</p>
                <ul>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>a copy of a Social Security card issued by the Social Security Administration</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>a certified or official copy of a birth certificate issued by the entity authorized to issue the birth certificate</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    {" "}
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>
                                    a copy of a driver's license, an identification card issued by the motor vehicle administration, or any other government issued
                                    identification
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <p>Please only send copies of documents, not original documents.</p>
            <div>
                <p>Send everything to TransUnion's address below:</p>
            </div>
            <div>
                <strong>TransUnion</strong>
            </div>
            <div>
                <strong>P.O. Box 160</strong>
            </div>
            <div>
                <strong>Woodlyn, PA 19094</strong>
            </div>
            <p></p>
            <p>TransUnion accepts either standard or certified mail.</p>
        </div>
    );
};

export default HowFreezeTheirCredit;
